export const MODULES = {
  DASHBOARD: "dashboard",
  ACCOUNTS: "accounts",
  COMPANIES: "companies",
  USERS: "users",
  DEALS: "deals",
  LEADS: "leads",
  ROLES: "roles",
  PRODUCTS: "products",
  STAGES: "stages",
  CUSTOMMODULES: "customModules",
  DUPLICATELEADS: "duplicateLeads",
  ENROLLMENT: "enrollment",
  PROFILINGFORM: "profilingForm",
};

export const MODULES_ACTIONS = {
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
  READ: "read",
};
